import React, { ReactElement } from 'react';
import { Navigate } from 'react-router-dom';
import useAuth from 'src/hooks/useAuth';
import LoadingIndicator from 'src/lib/components/LoadingIndicator';

export function withAdminProtection(
  Component: (props: any) => ReactElement,
  fallbackPath = '/detections'
): (props: any) => ReactElement {
  const ProtectedComponent = (props: any) => {
    const { auth } = useAuth();

    // Still loading auth
    if (auth === undefined) {
      return (
        <div style={{ display: 'flex', justifyContent: 'center', padding: '40px' }}>
          <LoadingIndicator message="Checking permissions..." loaderSize={50} />
        </div>
      );
    }

    // Not authenticated
    if (!auth) {
      return <Navigate to="/login" replace />;
    }

    // Not admin - redirect to fallback
    if (!auth.isFullAdmin()) {
      return <Navigate to={fallbackPath} replace />;
    }

    // User is admin, render the component
    return <Component {...props} />;
  };

  ProtectedComponent.displayName = `WithAdminProtection(${
    (Component as React.ComponentType).displayName ||
    (Component as React.ComponentType).name ||
    'Component'
  })`;
  
  return ProtectedComponent;
}